import gql from 'graphql-tag';

export const schema = gql`
  mutation TagResource($arn: String!, $tags: [ResourceTagInput!]!) {
    tagResource(arn: $arn, tags: $tags)
  }
`;
